































import {
  computed, defineComponent, ref, watch, onBeforeUnmount,
} from '@vue/composition-api';
import { Radio } from '@hb/coffee';
import { RightPackageSourceEnum, RightPackageTypeEnum } from '@/api/rights/types';
import { showOutSideContractList } from '@/views_v2/apply-product/components/rights/zhenxiang-card/hello-app/showOutSideContractList';
import { ForceReadService } from '@/widgets/right-contract';
import { rightsManager } from '../RightsManager';
import type { RightsContext } from '../types';

export default defineComponent({
  name: 'NormalTab',
  components: {
    Radio,
  },
  emits: ['contract-click'],
  setup(props, { emit }) {
    /** 勾选状态 */
    const checkStatus = ref(false);
    /** 合约包裹ref */
    const contractWrapperRef = ref<HTMLDivElement | null>(null);

    // 创建强制阅读服务实例
    const contractInstance = ForceReadService({
      packageType: RightPackageTypeEnum.CHANNEL_B,
      forceReadFromScene: RightPackageSourceEnum.LOAN_APPLY,
    });

    const show = computed(() => rightsManager.context.value.tipShow);
    watch(show, (newVal) => {
      if (newVal && contractWrapperRef.value) {
        /** 滚动到合约可视区域 */
        contractWrapperRef.value.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
        });
      }
    });

    /** 点击协议名称 - 打开协议弹窗 */
    const handleClick = async () => {
      const contextValue = rightsManager.context.value as RightsContext;
      const { contractInfo } = contextValue.rightSummaryData || {};

      // 上报查看协议埋点
      const trackingManager = rightsManager.getTrackingManager();
      trackingManager.trackAgreementView(contextValue);

      rightsManager.updateContext({
        contractShow: true,
      }, false);

      if (contractInfo) {
        // 如果需要使用外部合同列表，则使用合同列表
        if (contractInfo.isUseContractList && contractInfo.contractList?.length) {
          await showOutSideContractList(contractInfo);
          rightsManager.updateContext({
            contractShow: false,
          }, false);
        } else {
          // 否则使用强制阅读服务
          const handleRes = await contractInstance.handleForceRead({
            contractScene: contractInfo.scene || '',
            tqParams: {},
            preview: true,
            rightsModelType: contextValue.rightSummaryData?.rightsModelType,
          });
          // 只有勾选时再改变勾选状态
          if (handleRes) {
            checkStatus.value = handleRes;
            // 更新权益协议展示状态
            emit('check-status-change', handleRes);
          }

          rightsManager.updateContext({
            contractShow: false,
          }, false);
        }
      }

      emit('contract-click');
    };

    const handleChange = (status: boolean) => {
      if (!status) {
        rightsManager.updateContext({
          tipShow: false,
        }, false);
      }
      emit('check-status-change', status);
    };

    // 组件卸载前销毁实例
    onBeforeUnmount(() => {
      contractInstance.destroyInstance();
    });

    return {
      handleClick,
      handleChange,
      checkStatus,
      show,
      contractWrapperRef,
    };
  },
});
